// Globals
import React from 'react';

// Components
import SignInContainer from '../SignInContainer/SignInContainer';
import { StyledFormWrapper, StyledPageWrapper, StyledBanner, StyledFormSection } from './AuthPageContentStyles';

const AuthPageContent = () => {
  return (
    <StyledPageWrapper>
      <StyledFormSection>
        <StyledFormWrapper>
          <SignInContainer />
        </StyledFormWrapper>
      </StyledFormSection>
      <StyledBanner />
    </StyledPageWrapper>
  );
};

export default AuthPageContent;
